import React, { Suspense, lazy } from 'react';
import { APP, EVENT_NAME } from 'appenv';
import { Helmet } from 'react-helmet';

const LandingTemplate = lazy(() => {
  switch (APP) {
    case 'polyu618':
      return import('./templates/Landing618Template');
    case 'paloalto623':
      return import('./templates/Landing623Template');
    case 'ms624':
      return import('./templates/Landing624Template');
    case 'scmp711':
      return import('./templates/Landing711Template');
    case 'lighthouse710':
      return import('./templates/Landing710Template');
    default:
      return import('./templates/Landing608Template');
  }
});

const LandingTemplateSwitch = () => (
  <Suspense fallback={null}>
    <Helmet>
      <meta charSet="utf-8" />
      <title>{`Landing Page | ${EVENT_NAME}`}</title>
      <meta name="description" content={`Landing page of ${EVENT_NAME}.`} />
    </Helmet>
    <LandingTemplate />
  </Suspense>
);

export default LandingTemplateSwitch;
